export default {
    ACOLHIMENTO_COM_CLASSIFICACAO_DE_RISCO: '0301060118',
    ADMINISTRACAO_DE_MEDICAMENTOS_NA_ATENCAO_ESPECIALIZADA: '0301100012',
    AFERICAO_DE_TEMPERATURA: '0301100250',
    AFERICAO_PRESSAO_ARTERIAL: '0301100039',
    AJUDA_DE_CUSTO_PARA_ALIMENTACAO_DE_ACOMPANHANTE_SEM_PERNOITE: '0803010052',
    AJUDA_DE_CUSTO_PARA_ALIMENTACAO_DE_PACIENTE_SEM_PERNOITE: '0803010028',
    ATEND_URG_ATENCAO_PRIMARIA_OBS_ATE_8_HORAS: '0301060045',
    ATEND_URG_OBS_ATE_24_HORAS_ATENCAO_ESPECIALIZADA: '0301060029',
    AVALIACAO_ANTROPOMETRICA: '0101040024',
    COLETA_DE_MATERIAL_PARA_EXAME_CITOPATOLOGICO_DE_COLO_DE_UTERO: '0201020033',
    COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL: '0201020041',
    CURATIVO_ESPECIAL: '0214010104',
    CURATIVO_SIMPLES: '0301100276',
    DOSAGEM_DE_HEMOGLOBINA_GLICOSILADA: '0202010503',
    EMISSOES_OTOACUSTICAS_EVOCADAS_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA: '0211070149',
    ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA: '0301040079',
    FUNDOSCOPIA: '0211060100',
    GLICEMIA_CAPILAR: '0214010015',
    MEDICAO_DE_ALTURA: '0101040075',
    MEDICAO_DE_PESO: '0101040083',
    POTENCIAL_EVOCADO_AUDITIVO_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA: '0211070270',
    RESSONANCIA_MAGNETICA_DE_CRANIO: '0207010064',
    TESTE_RAPIDO_PARA_DETECCAO_DE_INFECCAO_PELO_HBV: '0214010104',
    TOMOGRAFIA_COMPUTADORIZADA_DO_CRANIO: '0206010079',
    ULTRASSONOGRAFIA_DOPPLER_DE_FLUXO_OBSTETRICO: '0205010059',
    ULTRASSONOGRAFIA_OBSTETRICA: '0205020143',
    ULTRASSONOGRAFIA_OBSTETRICA_C_DOPPLER_COLORIDO_E_PULSADO: '0205020151',
    ULTRASSONOGRAFIA_TRANSFONTANELA: '0205020178',
    UNIDADE_DE_REMUNERACAO_PARA_DESLOCAMENTO_DE_ACOMPANHANTE_POR_TRANSPORTE_TERRESTRE: '0803010109',
    UNIDADE_DE_REMUNERACAO_PARA_DESLOCAMENTO_DE_PACIENTE_POR_TRANSPORTE_TERRESTRE: '0803010125',
}
